import React from 'react';
import { Box } from '@mui/material';
import { StyledSwitch } from '../../styles/StyledInputs';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledFieldRow, StyledLabel } from '../../styles/styles';

interface InvestorGoogleSearchToggleProps {
  globalSearchEnabled: boolean;
  sandboxSearchEnabled: boolean;
  sandboxSearchLocked: boolean;
  onToggle: (enabled: boolean) => void;
}

export default function InvestorGoogleSearchToggle({
  globalSearchEnabled,
  sandboxSearchEnabled,
  sandboxSearchLocked,
  onToggle,
}: InvestorGoogleSearchToggleProps) {
  return (
    <StyledFieldRow unrestrictedWidth sx={{ mb: 2 }}>
      <StyledSwitch
        checked={globalSearchEnabled || sandboxSearchEnabled}
        onChange={(event) => onToggle(event.target.checked)}
        disabled={sandboxSearchLocked}
      />
      <Box sx={{ ml: 2 }}>
        <StyledLabel unrestricted>Google Search in this sandbox</StyledLabel>
        <StyledFieldDescription stacked>
          {globalSearchEnabled
            ? 'Enabled globally in configuration — cannot turn off here.'
            : 'Turn on to test Google Search for this preview session only (does not change global config).'}
        </StyledFieldDescription>
      </Box>
    </StyledFieldRow>
  );
}
